import { render, staticRenderFns } from "./orderItemPreviewList.vue?vue&type=template&id=e04a4242&"
import script from "./orderItemPreviewList.vue?vue&type=script&lang=js&"
export * from "./orderItemPreviewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports